import React, { useState } from 'react';
import FloatingMenu from '../FloatingMenu';
import narimanPhoto from '../../assets/images/about/nariman.png';
import nedaPhoto from '../../assets/images/about/neda.png';

// Decorative SVG patterns
const FlowerPattern = () => (
  <svg width="100" height="100" viewBox="0 0 100 100" style={{position: 'absolute', opacity: 0.08}}>
    <path d="M30,50 C30,40 40,30 50,30 C60,30 70,40 70,50 C70,60 60,70 50,70 C40,70 30,60 30,50 Z" fill="#f72585" />
    <path d="M50,30 C50,20 60,10 70,10 C80,10 90,20 90,30 C90,40 80,50 70,50 C60,50 50,40 50,30 Z" fill="#a259c6" />
    <path d="M70,50 C70,40 80,30 90,30 C100,30 110,40 110,50 C110,60 100,70 90,70 C80,70 70,60 70,50 Z" fill="#f72585" />
    <path d="M50,70 C50,60 60,50 70,50 C80,50 90,60 90,70 C90,80 80,90 70,90 C60,90 50,80 50,70 Z" fill="#a259c6" />
    <path d="M10,30 C10,20 20,10 30,10 C40,10 50,20 50,30 C50,40 40,50 30,50 C20,50 10,40 10,30 Z" fill="#f72585" />
    <path d="M10,70 C10,60 20,50 30,50 C40,50 50,60 50,70 C50,80 40,90 30,90 C20,90 10,80 10,70 Z" fill="#a259c6" />
    <path d="M30,10 C30,0 40,-10 50,-10 C60,-10 70,0 70,10 C70,20 60,30 50,30 C40,30 30,20 30,10 Z" fill="#f72585" />
    <path d="M30,90 C30,80 40,70 50,70 C60,70 70,80 70,90 C70,100 60,110 50,110 C40,110 30,100 30,90 Z" fill="#a259c6" />
  </svg>
);

const About = () => {
  // State for hover effects
  const [hoveredCard, setHoveredCard] = useState(null);

  // Styles for the page components
  const styles = {
    container: {
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      padding: '20px',
      fontFamily: 'Montserrat, Arial, sans-serif',
      backgroundImage: 'linear-gradient(to bottom, rgba(255,255,255,0.95), rgba(255,255,255,0.98)), linear-gradient(45deg, rgba(225,190,231,0.1) 25%, transparent 25%, transparent 50%, rgba(225,190,231,0.1) 50%, rgba(225,190,231,0.1) 75%, transparent 75%)',
      backgroundSize: '100% 100%, 40px 40px',
    },
    header: {
      color: '#a259c6',
      textAlign: 'center',
      marginBottom: '20px',
      fontFamily: 'Playfair Display, serif',
      letterSpacing: '1.5px',
      textShadow: '0 2px 4px rgba(247, 37, 133, 0.08)'
    },
    subHeader: {
      color: '#f72585',
      marginTop: '30px',
      marginBottom: '15px',
      fontFamily: 'Playfair Display, serif',
      letterSpacing: '1px',
      position: 'relative',
      paddingBottom: '10px'
    },
    intro: {
      textAlign: 'center',
      maxWidth: '900px',
      margin: '0 auto 40px',
      lineHeight: '1.6',
      fontSize: '1.1rem',
      color: '#4a4a4a',
      padding: '15px 20px',
      borderRadius: '20px',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      boxShadow: '0 4px 12px rgba(247, 37, 133, 0.08)',
    },
    cardsContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '30px',
      maxWidth: '1200px',
      margin: '40px auto'
    },
    card: {
      width: '350px',
      borderRadius: '18px',
      overflow: 'hidden',
      boxShadow: '0 8px 20px rgba(247, 37, 133, 0.15)',
      transition: 'all 0.4s ease-in-out',
      backgroundColor: 'white',
      border: '2px solid rgba(255, 182, 213, 0.3)'
    },
    cardHover: {
      transform: 'translateY(-10px)',
      boxShadow: '0 12px 28px rgba(247, 37, 133, 0.25)',
      border: '2px solid rgba(255, 182, 213, 0.7)'
    },
    imageContainer: {
      height: '250px',
      backgroundColor: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden'
    },
    placeholderImage: {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      backgroundColor: '#e0e0e0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '30px',
      color: '#a259c6'
    },
    cardContent: {
      padding: '25px',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      minHeight: '380px'
    },
    decorativeDivider: {
      width: '80%',
      height: '2px',
      margin: '15px auto',
      background: 'linear-gradient(to right, transparent, #ffb6d5, transparent)',
    },
    cardName: {
      margin: '0 0 10px 0',
      color: '#a259c6',
      fontFamily: 'Playfair Display, serif',
      letterSpacing: '1px',
      position: 'relative'
    },
    cardTitle: {
      margin: '0 0 15px 0',
      color: '#f72585',
      fontWeight: '500',
      fontSize: '16px',
      letterSpacing: '0.5px'
    },
    cardText: {
      lineHeight: '1.5',
      marginBottom: '15px',
      color: '#333333',
      fontSize: '0.95rem',
      flex: '1 1 auto'
    },
    socialLinks: {
      marginTop: 'auto',
      paddingTop: '15px'
    },
    socialLink: {
      color: '#a259c6',
      textDecoration: 'none',
      marginRight: '15px',
      fontWeight: 'bold',
      transition: 'all 0.3s',
      padding: '5px 12px',
      borderRadius: '20px',
      backgroundColor: 'rgba(224, 170, 255, 0.1)',
      display: 'inline-block',
      margin: '5px 10px 5px 0'
    },
    socialLinkHover: {
      color: '#ffffff',
      backgroundColor: '#f72585',
      boxShadow: '0 4px 8px rgba(247, 37, 133, 0.25)',
      transform: 'translateY(-2px)'
    },
    footer: {
      marginTop: '3rem',
      color: '#f72585',
      fontWeight: 'bold',
      textAlign: 'center',
      padding: '15px',
      borderRadius: '25px',
      backgroundImage: 'linear-gradient(to right, rgba(255, 182, 213, 0.1), rgba(224, 170, 255, 0.1), rgba(255, 182, 213, 0.1))',
    },
    contactSection: {
      maxWidth: '900px',
      margin: '0 auto',
      borderRadius: '20px',
      padding: '20px',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      boxShadow: '0 4px 12px rgba(247, 37, 133, 0.1)',
    }
  };
  
  return (
    <div className="page-section" style={styles.container}>
      <FloatingMenu />
      <FlowerPattern />
      <h1 style={styles.header}>About Us</h1>
      <div style={styles.intro}>
        <p>
          <b>Spicing Up Your Kitchen with AI & a Dash of Magic ✨</b><br/>
          Hello, gorgeous! Welcome to your divine digital kitchen companion! Our delightful creation blends the cozy warmth of home cooking with the seductive power of Generative AI and the elegant art of coding.
        </p>
      </div>
      
      <h2 style={{...styles.subHeader, textAlign: 'center'}}>Meet The Team</h2>
      <div style={styles.cardsContainer}>
        {/* Nariman's Card */}
        <div style={hoveredCard === 'nariman' ? {...styles.card, ...styles.cardHover} : styles.card} 
             className="team-card" 
             onMouseEnter={() => setHoveredCard('nariman')} 
             onMouseLeave={() => setHoveredCard(null)}>
          <div style={styles.imageContainer}>
            <img src={narimanPhoto} alt="Nariman Jafarieshlaghi" style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'cover'}} />
          </div>
          <div style={styles.cardContent}>
            <h3 style={styles.cardName}>Nariman Jafarieshlaghi</h3>
            <div style={styles.decorativeDivider}></div>
            <h4 style={styles.cardTitle}>AI Integrator & Creative Coder 💫</h4>
            <p style={styles.cardText}>
              A passionate innovator at the intersection of artificial intelligence, mathematics, and culinary arts, Nariman thrives on transforming complex challenges into elegant solutions. With a deep-rooted love for coding, strategic thinking honed through chess, and a flair for mathematical problem-solving, he brings a unique perspective to AI development.​

In his latest venture, Chefbelle, Nariman merges cutting-edge AI technology with everyday kitchen experiences. This interactive assistant not only simplifies meal planning and cooking but also embodies her commitment to enhancing daily life through intelligent design.​

Nariman's work reflects a harmonious blend of logic and creativity, aiming to make technology more accessible and enjoyable for everyone.
            </p>
            <div style={styles.socialLinks}>
              <a href="https://www.linkedin.com/in/narimanjafari/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={hoveredCard === 'nariman' ? {...styles.socialLink, ...styles.socialLinkHover} : styles.socialLink}>
                LinkedIn
              </a>
              <a href="https://github.com/snowholt" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={hoveredCard === 'nariman' ? {...styles.socialLink, ...styles.socialLinkHover} : styles.socialLink}>
                GitHub
              </a>
            </div>
          </div>
        </div>
        
        {/* Neda's Card */}
        <div style={hoveredCard === 'neda' ? {...styles.card, ...styles.cardHover} : styles.card} 
             className="team-card" 
             onMouseEnter={() => setHoveredCard('neda')} 
             onMouseLeave={() => setHoveredCard(null)}>
          <div style={styles.imageContainer}>
            <img src={nedaPhoto} alt="Neda Saberitabar" style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'cover'}} />
          </div>
          <div style={styles.cardContent}>
            <h3 style={styles.cardName}>Neda Saberitabar</h3>
            <div style={styles.decorativeDivider}></div>
            <h4 style={styles.cardTitle}>Computer Scientist & Data Analyst ✨</h4>
            <p style={styles.cardText}>
              Neda Saberitabar is the creative force behind the intelligence and elegance of our kitchen assistant. A specialist in artificial intelligence with a strong command of computer vision and large language models, he brings a rare ability to merge cutting-edge technology with real human needs. Her work doesn't just make our assistant function—it gives it personality, purpose, and the power to inspire healthier living.      </p>
            <div style={styles.socialLinks}>
              <a href="https://www.linkedin.com/in/neda-saberitabar-8b0211220/" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={hoveredCard === 'neda' ? {...styles.socialLink, ...styles.socialLinkHover} : styles.socialLink}>
                LinkedIn
              </a>
              <a href="https://github.com/nedasaberitabar" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={hoveredCard === 'neda' ? {...styles.socialLink, ...styles.socialLinkHover} : styles.socialLink}>
                GitHub
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <h2 style={styles.subHeader}>Our Mission</h2>
      <div style={{...styles.intro, marginTop: '20px'}}>
        <p>
          We're here to charm and inspire home cooks—especially our fellow ladies and beautiful families—to reduce food waste, embrace healthier eating habits, and create stress-free meals with a flutter of excitement. Our AI-powered whispers of culinary suggestions and sassy kitchen management make every meal preparation a tantalizing adventure. Let us seduce your taste buds while saving you time! 🌸
        </p>
      </div>
      
      <h2 style={styles.subHeader}>Contact & Links</h2>
      <div style={styles.contactSection}>
        <ul style={{listStyleType: 'none', padding: '0'}}>
          <li style={{margin: '10px 0'}}>✨ Project Repository: <a href="https://github.com/snowholt/chefbelle" target="_blank" rel="noopener noreferrer" style={{color: '#f72585', textDecoration: 'none', fontWeight: 'bold'}}>GitHub</a></li>
          <li style={{margin: '10px 0'}}>💫 Connect on LinkedIn: <a href="https://www.linkedin.com/in/narimanjafari/" target="_blank" rel="noopener noreferrer" style={{color: '#f72585', textDecoration: 'none', fontWeight: 'bold'}}>Nariman</a> & <a href="https://www.linkedin.com/in/neda-saberitabar-8b0211220/" target="_blank" rel="noopener noreferrer" style={{color: '#f72585', textDecoration: 'none', fontWeight: 'bold'}}>Neda</a></li>
          <li style={{margin: '10px 0'}}>🌸 Kaggle: <a href="https://www.kaggle.com/code/snowholt/chefbelle-an-ai-kitchen-assistant" target="_blank" rel="noopener noreferrer" style={{color: '#f72585', textDecoration: 'none', fontWeight: 'bold'}}>ChefBelle AI Kitchen Assistant</a></li>
        </ul>
      </div>
      
      <p style={styles.footer}>Made with ❤️, code, and a sprinkle of AI magic by Nariman & Neda ✨</p>
    </div>
  );
};

export default About;
